<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

document.addEventListener("DOMContentLoaded", function() {
  function traducirFacets() {
    document.querySelectorAll('.facets__text').forEach(function(elemento) {
      const texto = elemento.textContent.trim();

      if (texto === 'Availability') {
        elemento.textContent = 'Disponibilidad';
      } else if (texto === 'Price') {
        elemento.textContent = 'Precio';
      }
    });
  }

  // Ejecutar al cargar
  traducirFacets();

  // Observar cambios dinámicos en el DOM (Shopify vuelve a renderizar los filtros)
  const observer = new MutationObserver(traducirFacets);
  observer.observe(document.body, { childList: true, subtree: true });
});


